
import {View} from 'backbone';
import template from 'common-views/quick-paste.ejs';
import constants from 'Constants.js';
import $ from 'jquery';

class QuickPasteModalView extends View {
    initialize(opts){
        super.initialize(opts);
        $('body').append(this.$el);
    }

    processPastedText(){
        this.model.set('pastedText', $('#pastedText').val(), {silent: true});
        let currentPastedText=this.model.get('pastedText'),captions=[],values=[];
        console.log('pasted Text',currentPastedText);

        // Separating by line breaks if any
        if(currentPastedText.indexOf('\n') > 0){
            let splitLineBreakArray=currentPastedText.split('\n');
            splitLineBreakArray.forEach((item)=>{
                if(item.indexOf(',') > 0){
                    let splitCommaArray=item.split(',');
                    captions.push(splitCommaArray[0]);
                    values.push(splitCommaArray[1]);
                }
                else{
                    captions.push(item);
                    values.push(item);
                }
            })
        }
        else{
            if (currentPastedText !== '') {
                let splitCommaArray=currentPastedText.split(',');
                captions.push(splitCommaArray[0]);
                values.push(splitCommaArray[1]);
            }
        }

        console.log('Captions Array',captions);
        console.log('Values Array',values);
        this.model.set('captions',captions,{silent:true});
        this.model.set('values',values,{silent:true});

    }

    updatePastedText(ev){
        this.model.set(ev.currentTarget.name,ev.currentTarget.value,{silent:true});
        if(this.model.get('pastedText')){
            $('.btn-select-item').prop('disabled', false).removeClass('ui-button-disabled').removeClass('ui-state-disabled');
        }
        else{
            $('.btn-select-item').prop('disabled', true).addClass('ui-button-disabled').addClass('ui-state-disabled');
        }
    }

    render(){
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.delegateEvents();

            $( constants.DIALOG_ID ).dialog({
                dialogClass: "no-close",
                autoOpen: true,
                height: 'auto',
                width: 400,
                modal: true,
                resizable: false,
                buttons: [
                    {
                        text: 'Ok',
                        disabled:true,
                        'class':'btn-select-item',
                        click: () => {
                            this.processPastedText();
                            resolve({captions:this.model.get('captions'),values:this.model.get('values')});
                            this.closeModal();
                        }
                    },
                    {
                        'text': 'Cancel',
                        click: () => {
                            resolve('Cancel');
                            this.closeModal();
                        }
                    }
                ],
                open: () => {
                    this.bindEvents();
                },
                close: () => {
                    this.unbindEvents();
                }
            });

            $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        });
    }

    bindEvents(){
        $('#dialog').find('textarea').keydown(e => this.updatePastedText(e));
    }

    unbindEvents(){
        $('#dialog').find('textarea').unbind();
    }

    closeModal(){
        $( constants.DIALOG_ID ).dialog("destroy").remove();
    }
}

export default QuickPasteModalView;